<template>
  <div
    :class="{
      'm-input_large': large,
      'm-input_small': small
    }"
    class="m-input m-calendar-input"
  >
    <DateInput
      :value="value"
      :placeholder="placeholder"
      class="input__field m-input__field"
      @input="onDateChange"
      @click="$emit('click')"
    />
    <MIcon
      :icon="iconCalendar"
      class="m-input__icon"
    />
  </div>
</template>

<script>
  import iconCalendar from 'assets/icons/calendar.svg';
  import MIcon from 'components/Design/MIcon';
  import DateInput from 'components/Inputs/Dates/common/DateInput';

  export default {
    name: 'MCalendarInput',
    components: {DateInput, MIcon},
    props: {
      value: {
        type: Date,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      large: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      withIcon: {
        type: Boolean,
        default: true
      },
      minDate: {
        type: Date,
        default: null
      },
      maxDate: {
        type: Date,
        default: null
      }
    },
    data () {
      return {
        iconCalendar
      };
    },
    methods: {
      onDateChange (date) {
        const fitDate = this.fitDateInRange(date);
        this.$emit('input', new Date(fitDate));
      },
      fitDateInRange (date) {
        if (this.minDate && date < this.minDate) {
          return this.minDate;
        }
        if (this.maxDate && date > this.maxDate) {
          return this.maxDate;
        }
        return date;
      }
    }
  };
</script>

<style>
  .m-calendar-input {
    position: relative;
  }

  .m-calendar-input .m-input__icon {
    color: var(--main-color);

    position: absolute;
    top: 7px;
    right: 7px;

    width: 16px;
    height: 16px;
  }

  .m-calendar-input.m-input_small .m-input__icon {
    top: 5px;
  }

  .m-calendar-input.m-input_large .m-input__icon {
    top: 10px;
    right: 10px;
  }
</style>
